import { setConsent, useConsent } from "@/utils/consent";
import { outlineButtonTw } from "./button";

export function CookieConsent() {
  const consent = useConsent();

  // undefined = still reading the stored choice; anything other than
  // "no choice yet" means the banner stays hidden.
  if (consent !== null) return null;

  return (
    <div className="fixed bottom-0 left-0 z-[9998] m-4 flex max-w-md flex-col gap-4 border border-darkGrey bg-white p-6 text-darkGrey shadow-lg">
      <p className="font-display text-xl">Cookies</p>
      <p className="text-sm opacity-75">
        We gebruiken cookies van Google Analytics, Google Ads en Meta om het
        gebruik van de website te analyseren en onze campagnes te verbeteren.
        Die plaatsen we alleen met jouw toestemming. Je kunt je keuze altijd
        aanpassen via &quot;Cookie-instellingen&quot; onderaan de pagina.
      </p>
      <div className="flex flex-wrap gap-4">
        <button
          type="button"
          className="bg-black font-display text-white py-2 px-4 hover:scale-105 transition-all active:scale-100"
          onClick={() => setConsent("granted")}
        >
          Accepteren
        </button>
        <button
          type="button"
          className={outlineButtonTw}
          onClick={() => setConsent("denied")}
        >
          Weigeren
        </button>
      </div>
    </div>
  );
}
